import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { Card, CardContent } from "./ui/card";

export const Contact = () => {
  return (
    <section
      id="contact"
      className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-50 to-white"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Get in Touch
          </h2>
          <p className="text-xl text-gray-600">
            Contact us to discuss how we can help your business increase value, reduce risk and improve efficiency
          </p>
        </div>

        {/* Contact Information Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Email Card */}
          <Card className="border-2 border-gray-100 hover:border-[#1e3a8a] transition-all duration-300 hover:shadow-xl">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <Mail className="w-8 h-8 text-[#1e3a8a]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Email</h3>
              <a
                href="mailto:ludvik.thorsteinsson1@outlook.com"
                className="text-[#1e3a8a] hover:underline text-lg break-all"
              >
                ludvik.thorsteinsson1@outlook.com
              </a>
            </CardContent>
          </Card>

          {/* Phone Card */}
          <Card className="border-2 border-gray-100 hover:border-[#1e3a8a] transition-all duration-300 hover:shadow-xl">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <Phone className="w-8 h-8 text-[#1e3a8a]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Phone</h3>
              <a
                href="tel:+85297886632"
                className="text-[#1e3a8a] hover:underline text-lg"
              >
                +852 9788 6632
              </a>
            </CardContent>
          </Card>

          {/* Location Card */}
          <Card className="border-2 border-gray-100 hover:border-[#1e3a8a] transition-all duration-300 hover:shadow-xl">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <MapPin className="w-8 h-8 text-[#1e3a8a]" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Location
              </h3>
              <p className="text-gray-700 text-lg">
                Unit 2904-05, 29/F, Universal Trade Centre, 3 Arbuthnot Road, Central, Hong Kong
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Availability Info */}
        <div className="mt-16 max-w-2xl mx-auto">
          <Card className="border-2 border-gray-100 bg-blue-50">
            <CardContent className="p-8 text-center">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Availability
              </h3>
              <p className="text-gray-700 text-lg">
                Monday - Friday: 9:00 AM - 6:00 PM HKT
                <br />
                Weekend consultations by appointment
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
